var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "results-container",
      style: { minHeight: _vm.request ? "100px" : undefined },
      attrs: { disabled: _vm.request },
    },
    [
      _vm.request
        ? _c("Spinner", { attrs: { overlay: "", size: "75" } })
        : _vm._e(),
      _vm._v(" "),
      _vm.resultsHaveData
        ? _c(
            _vm.resultComponentName,
            _vm._b(
              {
                tag: "component",
                on: {
                  sort: function ($event) {
                    _vm.sort = $event
                  },
                  viewgroup: function ($event) {
                    _vm.restoreOnViewGroupLeave = {
                      page: _vm.page,
                      sort: _vm.sort,
                    }
                    _vm.viewGroup = $event.id
                    _vm._viewGroupName = $event.displayName
                  },
                },
              },
              "component",
              _vm.resultComponentData,
              false
            ),
            [
              _c("BreadCrumbs", {
                attrs: {
                  slot: "breadcrumbs",
                  crumbs: _vm.breadCrumbs,
                  disabled: !!_vm.request,
                },
                slot: "breadcrumbs",
              }),
              _vm._v(" "),
              _c("Totals", {
                staticClass: "result-totals",
                attrs: {
                  slot: "totals",
                  initialResults: _vm.results,
                  type: _vm.id,
                  indexId: _vm.indexId,
                },
                on: {
                  update: function ($event) {
                    _vm.paginationResults = $event
                  },
                },
                slot: "totals",
              }),
              _vm._v(" "),
              !_vm.viewGroup
                ? _c("GroupBy", {
                    attrs: {
                      slot: "groupBy",
                      type: _vm.id,
                      results: _vm.results,
                      disabled: !!_vm.request,
                    },
                    slot: "groupBy",
                  })
                : _c(
                    "button",
                    {
                      staticClass: "btn btn-sm btn-primary",
                      attrs: { slot: "groupBy" },
                      on: { click: _vm.leaveViewgroup },
                      slot: "groupBy",
                    },
                    [
                      _c("span", { staticClass: "fa fa-angle-double-left" }),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t(
                              "results.resultsView.navigation.backToGroupedResults"
                            )
                          )
                      ),
                    ]
                  ),
              _vm._v(" "),
              _vm.concordanceAnnotationOptions.length > 1
                ? _c(
                    "div",
                    {
                      attrs: { slot: "annotation-switcher" },
                      slot: "annotation-switcher",
                    },
                    [
                      _c("label", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("results.resultsView.selectAnnotation")
                          ) + ": "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "btn-group" },
                        _vm._l(_vm.concordanceAnnotationOptions, function (a) {
                          return _c(
                            "button",
                            {
                              staticClass: "btn btn-default btn-sm",
                              class: {
                                active: a.id === _vm.concordanceAnnotationId,
                              },
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  _vm.concordanceAnnotationId = a.id
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$tAnnotDisplayName(a)))]
                          )
                        }),
                        0
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("Pagination", {
                staticStyle: { display: "block", margin: "10px 0" },
                attrs: {
                  slot: "pagination",
                  page: _vm.pagination.shownPage,
                  maxPage: _vm.pagination.maxShownPage,
                  disabled: !!_vm.request,
                },
                on: {
                  change: function ($event) {
                    _vm.page = $event
                  },
                },
                slot: "pagination",
              }),
              _vm._v(" "),
              _c("Sort", {
                attrs: {
                  slot: "sort",
                  hits: _vm.isHits,
                  docs: _vm.isDocs,
                  groups: _vm.isGroups,
                  corpus: _vm.corpus,
                  annotations: _vm.sortAnnotations,
                  metadata: _vm.sortMetadata,
                  disabled: !!_vm.request,
                },
                slot: "sort",
                model: {
                  value: _vm.sort,
                  callback: function ($$v) {
                    _vm.sort = $$v
                  },
                  expression: "sort",
                },
              }),
              _vm._v(" "),
              _vm.exportEnabled
                ? _c("Export", {
                    attrs: {
                      slot: "export",
                      results: _vm.results,
                      type: _vm.id,
                      disabled: !!_vm.request,
                      annotations: _vm.exportAnnotations,
                      metadata: _vm.exportMetadata,
                    },
                    slot: "export",
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm.results
        ? _c("div", { staticClass: "no-results-found" }, [
            _vm._v(_vm._s(_vm.$t("results.resultsView.noResultsFound"))),
          ])
        : !_vm.valid
        ? _c("div", { staticClass: "no-results-found" }, [
            _vm._v(
              "\n\t\t" +
                _vm._s(_vm.$t("results.resultsView.inactiveView")) +
                "\n\t"
            ),
          ])
        : _vm.error != null
        ? _c("div", { staticClass: "no-results-found" }, [
            _c("span", {
              staticClass: "fa fa-exclamation-triangle text-danger",
            }),
            _c("br"),
            _vm._v(" "),
            _c("span", { domProps: { innerHTML: _vm._s(_vm.error) } }),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-default",
                attrs: {
                  type: "button",
                  title: _vm.$t("results.resultsView.tryAgainTitle").toString(),
                },
                on: {
                  click: function ($event) {
                    return _vm.markDirty()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("results.resultsView.tryAgain")))]
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }